<template>
  <div class="nav-bar">
    <div
      v-touch:moved="touchStart"
      v-touch:moving="touchMove"
      v-touch:end="stopDrag"
      :class="['content', {'dragging': isDragging}]"
      :style="wrapperStyle"
    >
      <tree-menu
        :items="MENU"
        :max-depth="3"
      >
        <vue-client-only slot="prepend">
          <ul v-if="!adaptive.isDesktop">
            <mobile-city />
            <a href="/stores" class="link">
              <f-sprite-icon :icon-link="$options.icons.IconPoint.id" />
              Магазины
            </a>
            <mobile-search />
            <mobile-account />
          </ul>
        </vue-client-only>

        <vue-client-only slot="append" class="mobile-contacts">
          <div class="mobile-contacts" v-if="!adaptive.isDesktop">
            <h3>8 800 770 01 01</h3>
            <p>Мы принимаем звонки с 7:00 до 22:00 (мск).</p>
            <p>Звонок по России бесплатный.</p>
          </div>
        </vue-client-only>
      </tree-menu>
    </div>

    <transition name="fade">
      <div
        v-if="$f.navOpened"
        class="overlay"
        @click="$f.hideNav()"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';

import treeMenu from './tree-menu.vue';
import MobileCity from './mobile-city.vue';
import MobileSearch from './mobile-search.vue';
import MobileAccount from './mobile-account.vue';

import IconPoint from '../../assets/icons/point.svg';

export default {
  name: 'nav-bar',

  components: {
    treeMenu,
    MobileCity,
    MobileSearch,
    MobileAccount,
    VueClientOnly,
  },
  inject: ['adaptive'],
  icons: {
    IconPoint,
  },
  data: () => ({
    isDragging: false,
    dragStartX: 0,
    dragStartY: 0,
    dragDiffX: 0,
  }),
  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
    }),
    wrapperStyle() {
      if (this.$isServer || this.adaptive.isDesktop) return {};
      return {
        transform: `translateX(-${this.$f.navOpened ? this.dragDiffX : 320}px)`,
      }
    }
  },
  methods: {
    touchStart({ targetTouches }) {
      /*
      Для меню не очень актуальная фича,
      но нам нужен свой свайпер товаров/фото
      тк нет хорошего решения с snap-scroll
      нам надо будет его делать самим.
      */
      const [touch] = targetTouches;
      this.dragStartX = touch.clientX || 0;
      this.dragStartY = touch.clientY || 0;
    },
    touchMove({ targetTouches }) {
      /*
      Надо утащить математику направления
      у slick.js - она там идеальная
      */
      const [touch] = targetTouches;
      if (!this.isDragging && this.dragStartX - (touch.clientX || 0) > this.dragStartY - (touch.clientY || 0)) {
        return;
      }
      this.isDragging = true;
      this.dragDiffX = this.dragStartX - (touch.clientX || 0);
    },
    stopDrag() {
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragStartY = 0;
      if (this.dragDiffX > 50) {
        this.$f.hideNav();
      }
      this.dragDiffX = 0;
    },
  }
}
</script>

<style lang="scss">
.nav-bar {
  position: relative;
  z-index: 100;
  .content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 320px;
    overflow: hidden;
    background: $white;
    transform: translateX(-320px);
    transition: transform .2s;
    &.dragging {
      transition: none;
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    background: rgba(51, 51, 51, .64);
  }
  .close {
    width: 24px;
    height: 24px;
    color: $gray_lu;
  }
  .mobile-contacts {
    margin-top: auto;
    padding: $containerGapMobile;
    h3 {
      margin: 4px 0;
      font-size: 16px;
      line-height: 20px;
      font-weight: normal;
    }
    p {
      color: $gray;
      font-size: 14px;
      line-height: 24px;
    }
  }
}

@include breakpoint("desktop") {
  .nav-bar {
    z-index: initial;
    border-top: 1px solid $gray_lu;
    .content {
      position: relative;
      top: auto;
      right: auto;
      left: auto;
      max-width: initial;
      overflow: visible;
      transform: none;
      transition: none;
    }
  }
  .mobile-contacts {
    display: none;
  }
}
</style>
